<template>
  <div class="portal-login-page">
    <!-- Background (CSS fallback, shows immediately) -->
    <div class="login-bg"></div>
    <div class="login-bg-particles"></div>
    <!-- Background video (lazy loaded) -->
    <video v-if="videoLoaded" class="login-bg-video" autoplay loop muted playsinline>
      <source :src="videoSrc" type="video/mp4" />
    </video>

    <!-- Main Card -->
    <div class="login-card">
      <!-- Left Illustration Panel -->
      <div class="card-left">
        <img src="../assets/login-illustration.png" alt="" class="left-illustration" />
      </div>

      <!-- Right Form Panel -->
      <div class="card-right">
        <div class="form-wrapper">
          <!-- Brand -->
          <div class="form-brand">
            <div class="brand-logo">
              <img src="../assets/login-logo.png" alt="" class="brand-logo-img" />
            </div>
            <div class="brand-info">
              <div class="brand-name">凯泰铭集团</div>
              <div class="brand-sub">KAITAIMING GROUP</div>
            </div>
          </div>

          <a-spin :spinning="loading">
            <a-tabs default-active-key="1" class="login-tabs">
              <a-tab-pane key="1" tab="密码登录">
                <div class="form-group">
                  <div class="input-label">账号</div>
                  <a-input placeholder="请输入账号"
                           size="large"
                           v-model="userLogin.tenant"
                           v-on:keyup.enter="loginByUserName"
                           @input="handleTenantInput"
                           class="form-input">
                    <a-icon slot="prefix" type="home"></a-icon>
                  </a-input>
                </div>
                <div class="form-group">
                  <div class="input-label">密码</div>
                  <a-input-password placeholder="请输入密码"
                                    size="large"
                                    type="password"
                                    v-model="userLogin.password"
                                    v-on:keyup.enter="loginByUserName"
                                    class="form-input">
                    <a-icon slot="prefix" type="lock"></a-icon>
                  </a-input-password>
                </div>

                <div class="form-captcha" v-if="isCaptcha">
                  <a-input v-model="userLogin.captcha" placeholder="请输入验证码" size="large" class="captcha-input" v-on:keyup.enter="loginByUserName">
                    <a-icon slot="prefix" type="picture"></a-icon>
                  </a-input>
                  <div class="captcha-img" @click="refresh">
                    <img :src="captchaUrl" />
                  </div>
                </div>

                <a-button class="login-btn" @click="loginByUserName">
                  登录
                </a-button>

                <div class="form-error" v-if="errorMsg">
                  <span>{{ errorMsg }}</span>
                </div>
              </a-tab-pane>

              <a-tab-pane key="2" tab="短信验证码">
                <div class="form-group">
                  <div class="input-label">账号</div>
                  <a-input placeholder="请输入账号"
                           size="large"
                           v-model="phoneLogin.tenant"
                           v-on:keyup.enter="loginByPhone"
                           @input="handlePhoneTenantInput"
                           class="form-input">
                    <a-icon slot="prefix" type="home"></a-icon>
                  </a-input>
                </div>
                <div class="form-group">
                  <div class="input-label">手机号</div>
                  <a-input placeholder="请输入手机号"
                           size="large"
                           v-model="phoneLogin.phone"
                           v-on:keyup.enter="loginByPhone"
                           class="form-input">
                    <a-icon slot="prefix" type="mobile"></a-icon>
                  </a-input>
                </div>
                <div class="form-group">
                  <div class="input-label">验证码</div>
                  <div class="sms-row">
                    <a-input placeholder="请输入验证码"
                             size="large"
                             v-model="phoneLogin.code"
                             v-on:keyup.enter="loginByPhone"
                             class="form-input sms-input">
                      <a-icon slot="prefix" type="message"></a-icon>
                    </a-input>
                    <a-button class="sms-btn" :disabled="timer > 0 && timer !== 60" @click="sendSms">
                      {{ (timer === 0 || timer === 60) ? '获取验证码' : timer + 's' }}
                    </a-button>
                  </div>
                </div>

                <div class="form-captcha" v-if="isCaptcha">
                  <a-input v-model="phoneLogin.captcha" placeholder="请输入验证码" size="large" class="captcha-input" v-on:keyup.enter="loginByPhone">
                    <a-icon slot="prefix" type="picture"></a-icon>
                  </a-input>
                  <div class="captcha-img" @click="refresh">
                    <img :src="captchaUrl" />
                  </div>
                </div>

                <a-button class="login-btn" @click="loginByPhone">
                  登录
                </a-button>

                <div class="form-error" v-if="errorMsg">
                  <span>{{ errorMsg }}</span>
                </div>
              </a-tab-pane>
            </a-tabs>
          </a-spin>

          <div class="form-back" @click="goBack">
            <a-icon type="arrow-left" />
            <span>返回门户</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trim from 'lodash.trim';
import http from '../public/http';
import * as $url from '../public/url';

export default {
  name: 'PortalLogin',
  data() {
    return {
      videoLoaded: false,
      videoSrc: '',
      loading: false,
      errorMsg: '',
      userLogin: {
        tenant: '',
        userName: '',
        password: '',
        captcha: '',
        identityType: 'UsernameAndPassword'
      },
      phoneLogin: {
        tenant: '',
        phone: '',
        code: '',
        captcha: ''
      },
      isCaptcha: false,
      captchaUrl: '',
      timer: 60,
      timerInterval: null
    };
  },
  created() {
    this.triggerCaptcha().then((res) => {
      if (res) {
        this.getCaptcha();
      }
    });
    // 延迟加载背景视频，优先加载页面其他资源
    setTimeout(() => {
      this.videoSrc = '/login-bg.mp4';
      this.videoLoaded = true;
    }, 1500);
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  methods: {
    handleTenantInput() {
      if (this.userLogin.tenant) {
        this.userLogin.tenant = this.userLogin.tenant.toUpperCase();
      }
    },
    handlePhoneTenantInput() {
      if (this.phoneLogin.tenant) {
        this.phoneLogin.tenant = this.phoneLogin.tenant.toUpperCase();
      }
    },

    refresh() {
      this.triggerCaptcha().then((res) => {
        if (res) {
          this.getCaptcha();
        }
      });
    },

    triggerCaptcha() {
      return new Promise((resolve) => {
        this.loading = true;
        const url = $url.getBackendApiUrl('captcha/trigger?appKey=portal');
        http.get(url).then((res) => {
          if (res.data.success && res.data.data) {
            this.isCaptcha = true;
            resolve(true);
          }
          if (res.data.success && res.data.data === false) {
            this.isCaptcha = false;
          }
          if (res.data.success === false) {
            this.isCaptcha = false;
            this.errorMsg = res.data.errMessage;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.errorMsg = '系统内部服务错误';
        });
      });
    },

    getCaptcha() {
      this.loading = true;
      const url = $url.getBackendApiUrl('captcha/get?appKey=portal');
      http.get(url, { responseType: 'arraybuffer' }).then((res) => {
        this.loading = false;
        if (res.data instanceof ArrayBuffer) {
          this.captchaUrl = 'data:image/jpg;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        }
      }).catch(() => {
        this.loading = false;
        this.errorMsg = '获取验证码失败';
      });
    },

    startTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.timerInterval = setInterval(() => {
        this.timer -= 1;
        if (this.timer === 0) {
          clearInterval(this.timerInterval);
          this.timer = 60;
        }
      }, 1000);
    },

    sendSms() {
      this.errorMsg = '';
      if (!trim(this.phoneLogin.tenant)) {
        this.errorMsg = '请输入企业域';
        return;
      }
      if (!trim(this.phoneLogin.phone)) {
        this.errorMsg = '请输入手机号';
        return;
      }

      this.loading = true;
      const url = $url.getBackendApiUrl('authencation/oauth2/login/send/message/code');
      http.post(url, this.phoneLogin, { headers: { 'Content-type': 'application/json;charset=UTF-8', tenant: this.phoneLogin.tenant } }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message.success('短信验证码发送成功');
          this.errorMsg = '';
          this.timer = 59;
          this.startTimer();
        } else if (res.status === 200 && !res.data.success && res.data.errCode === 'PHONE_SEND_MESSAGE_CODE_COUNT_LIMIT') {
          this.errorMsg = '请不要频繁操作获取验证码';
          this.timer = 59;
          this.startTimer();
        } else if (res.data && res.data.errMessage) {
          this.errorMsg = res.data.errMessage;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error('短信验证码获取失败');
      });
    },

    loginByUserName() {
      this.errorMsg = '';

      if (!trim(this.userLogin.tenant)) {
        this.errorMsg = '请输入企业域';
        return;
      }
      if (!trim(this.userLogin.userName)) {
        this.errorMsg = '请输入用户名';
        return;
      }
      if (!trim(this.userLogin.password)) {
        this.errorMsg = '请输入密码';
        return;
      }

      this.loading = true;
      const url = $url.getBackendApiUrl('authencation/oauth2/login/user');
      http.post(url, this.userLogin, { headers: { 'Content-type': 'application/json;charset=UTF-8', tenant: this.userLogin.tenant } }).then((res) => {
        this.loading = false;
        if (res.status !== 200 || !res.data.success) {
          this.errorMsg = (res.data && res.data.errMessage) ? res.data.errMessage : '登录失败';
          this.triggerCaptcha().then((captchaNeeded) => {
            if (captchaNeeded) {
              this.getCaptcha();
            }
          });
          return;
        }

        const loginData = res.data.data;
        this.$store.dispatch('setLoginState', {
          token: loginData.data || loginData.ticket || '',
          userInfo: {
            userName: this.userLogin.userName,
            tenant: this.userLogin.tenant
          }
        });
        this.$router.push('/portal-home');
      }).catch(() => {
        this.loading = false;
        this.errorMsg = '登录失败';
      });
    },

    loginByPhone() {
      this.errorMsg = '';

      if (!trim(this.phoneLogin.tenant)) {
        this.errorMsg = '请输入企业域';
        return;
      }
      if (!trim(this.phoneLogin.phone)) {
        this.errorMsg = '请输入手机号';
        return;
      }
      if (!trim(this.phoneLogin.code)) {
        this.errorMsg = '请输入验证码';
        return;
      }

      this.loading = true;
      const url = $url.getBackendApiUrl('authencation/oauth2/login/phone');
      http.post(url, this.phoneLogin, { headers: { 'Content-type': 'application/json;charset=UTF-8', tenant: this.phoneLogin.tenant } }).then((res) => {
        this.loading = false;
        if (res.status !== 200 || !res.data.success) {
          this.errorMsg = (res.data && res.data.errMessage) ? res.data.errMessage : '登录失败';
          this.triggerCaptcha().then((captchaNeeded) => {
            if (captchaNeeded) {
              this.getCaptcha();
            }
          });
          return;
        }

        const loginData = res.data.data;
        this.$store.dispatch('setLoginState', {
          token: loginData.data || loginData.ticket || '',
          userInfo: {
            phone: this.phoneLogin.phone,
            tenant: this.phoneLogin.tenant
          }
        });
        this.$router.push('/portal-home');
      }).catch(() => {
        this.loading = false;
        this.errorMsg = '登录失败';
      });
    },

    goBack() {
      this.$router.push('/portal');
    }
  }
};
</script>

<style lang="less" scoped>
.portal-login-page {
  height: 100%;
  background: #0a1628;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  font-family: 'PingFang SC', 'Microsoft YaHei', -apple-system, sans-serif;
}

/* Background */
.login-bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 50% 50%, #162a46 0%, #0a1628 60%, #060e1a 100%);
  z-index: 0;
}

.login-bg-particles {
  position: absolute;
  inset: 0;
  z-index: 1;
  background-image:
    radial-gradient(1px 1px at 10% 20%, rgba(14, 176, 193, 0.3) 0%, transparent 100%),
    radial-gradient(1px 1px at 25% 45%, rgba(14, 176, 193, 0.25) 0%, transparent 100%),
    radial-gradient(1px 1px at 40% 15%, rgba(255, 255, 255, 0.15) 0%, transparent 100%),
    radial-gradient(1px 1px at 55% 70%, rgba(14, 176, 193, 0.2) 0%, transparent 100%),
    radial-gradient(1px 1px at 70% 35%, rgba(255, 255, 255, 0.1) 0%, transparent 100%),
    radial-gradient(1px 1px at 85% 55%, rgba(14, 176, 193, 0.15) 0%, transparent 100%),
    radial-gradient(1px 1px at 15% 80%, rgba(255, 255, 255, 0.12) 0%, transparent 100%),
    radial-gradient(1px 1px at 60% 90%, rgba(14, 176, 193, 0.18) 0%, transparent 100%),
    radial-gradient(1px 1px at 90% 10%, rgba(255, 255, 255, 0.1) 0%, transparent 100%),
    radial-gradient(1.5px 1.5px at 35% 60%, rgba(14, 176, 193, 0.3) 0%, transparent 100%),
    radial-gradient(1px 1px at 5% 50%, rgba(255, 255, 255, 0.08) 0%, transparent 100%),
    radial-gradient(1px 1px at 80% 85%, rgba(14, 176, 193, 0.22) 0%, transparent 100%),
    radial-gradient(1px 1px at 45% 40%, rgba(255, 255, 255, 0.06) 0%, transparent 100%),
    radial-gradient(1px 1px at 95% 65%, rgba(14, 176, 193, 0.12) 0%, transparent 100%),
    radial-gradient(1px 1px at 50% 5%, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
}

/* Background video - lazy loaded, covers full screen */
.login-bg-video {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Main Card - exact from design: 1139x540, opacity 0.89, border-radius 10px */
.login-card {
  z-index: 10;
  display: flex;
  width: 1139px;
  height: 540px;
  background: #FFFFFF;
  border-radius: 10px;
  opacity: 0.89;
  box-shadow: -15px 15px 99px 0 rgba(48, 66, 84, 0.15);
  overflow: hidden;
  font-family: PingFangSC-Medium, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 20px;
  color: #273250;
  letter-spacing: 0;
  font-weight: 500;
  padding: 74px 82px 86px 36px;
}

/* Left Panel - design: 570x380 illustration area */
.card-left {
  width: 570px;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.left-illustration {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Right Panel */
.card-right {
  margin-left: 35px;
  width: 416px;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
}

.form-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Brand - design: logo 44x44 #012F51, name 20px #273250, sub 12px #273250 */
.form-brand {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
}

.brand-logo {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #012F51;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  overflow: hidden;
  flex-shrink: 0;
}

.brand-logo-img {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.brand-info {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #273250;
}

.brand-sub {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #273250;
  line-height: 17px;
}

/* Tabs */
.login-tabs {
  flex: 1;
}

.login-tabs /deep/ .ant-tabs-bar {
  border-bottom: 1px solid #E5E6EB;
  margin-bottom: 20px;
}

.login-tabs /deep/ .ant-tabs-nav .ant-tabs-tab {
  font-size: 14px;
  color: #86909C;
  padding: 8px 0;
  margin-right: 32px;
}

.login-tabs /deep/ .ant-tabs-nav .ant-tabs-tab-active {
  color: #012F51;
  font-weight: 500;
}

.login-tabs /deep/ .ant-tabs-ink-bar {
  background-color: #012F51;
  height: 2px;
}

/* Form inputs - design: 416x71, border 1px solid #C9CDD4, label 12px #4B596B */
.form-group {
  margin-bottom: 12px;
}

.input-label {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #4B596B;
  margin-bottom: 4px;
  line-height: 17px;
}

.form-input /deep/ .ant-input-affix-wrapper {
  border: 1px solid #C9CDD4;
  border-radius: 4px;
  height: 40px;

  &:hover {
    border-color: #012F51;
  }

  &:focus-within {
    border-color: #012F51;
    box-shadow: 0 0 0 2px rgba(1, 47, 81, 0.1);
  }
}

.form-input /deep/ .ant-input {
  font-size: 14px;
  color: #1D2129;
  height: 38px;
}

.form-input /deep/ .ant-input::placeholder {
  color: #86909C;
}

.form-input /deep/ .ant-input-prefix {
  color: #86909C;
}

/* SMS row */
.sms-row {
  display: flex;
  gap: 8px;

  .sms-input {
    flex: 1;
  }
}

.sms-btn {
  flex-shrink: 0;
  height: 40px;
  border-radius: 4px;
  font-size: 13px;
  color: #012F51;
  border-color: #012F51;
  padding: 0 12px;

  &:hover:not(:disabled) {
    color: #012F51;
    border-color: #012F51;
  }

  &:disabled {
    color: #86909C;
    border-color: #C9CDD4;
  }
}

/* Captcha */
.form-captcha {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;

  .captcha-input {
    flex: 1;
  }

  .captcha-input /deep/ .ant-input-affix-wrapper {
    border: 1px solid #C9CDD4;
    border-radius: 4px;
    height: 40px;
  }

  .captcha-img {
    cursor: pointer;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #C9CDD4;

    img {
      height: 100%;
    }
  }
}

/* Login button - design: 416x50, #012F51, border-radius 4px, text 16px white */
.login-btn {
  width: 100%;
  height: 44px;
  background: #012F51;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  letter-spacing: 0;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 8px;

  &:hover {
    background: #024070;
  }

  &:active {
    background: #012040;
  }
}

/* Error */
.form-error {
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #F53F3F;
}

/* Back */
.form-back {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: auto;
  padding-top: 16px;
  color: #86909C;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    color: #012F51;
  }
}
</style>
